module.exports = __webpack_public_path__ + "static/media/logo.1c271d2f.svg";